import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import UserBadge from './UserBadge';
import fetchWithAuth from './fetchWithAuth';
import './style-new.css';

import {
  FaEye,
  FaTrash,
  FaEdit,
  FaUsers,
  FaPlus,
  FaUsersCog,
  FaHome,
  FaFutbol
} from 'react-icons/fa';

const Games = () => {
  const [games, setGames] = useState([]);
  const [adminGroupIds, setAdminGroupIds] = useState([]);
  const [loggedInUserId, setLoggedInUserId] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const authToken = localStorage.getItem('authToken');
    if (!authToken) {
      navigate('/login');
      return;
    }

    const decoded = jwtDecode(authToken);
    setLoggedInUserId(decoded?.id);

    fetchGames(authToken);
    fetchAdminGroups(authToken);
  }, []);

  const fetchGames = async (authToken) => {
    try {
      const response = await fetchWithAuth('/api/games', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (!response.ok) {
        const err = await response.json();
        console.error('Error response from /api/games:', err);
        alert(`Error fetching games: ${err.message}`);
        return;
      }

      const data = await response.json();
      const now = new Date();
      const upcomingGames = data.games.filter(game => new Date(game.game_datetime) > now);
      setGames(upcomingGames);
    } catch (error) {
      console.error('Error fetching games:', error);
      alert('Failed to fetch games');
    }
  };

  const fetchAdminGroups = async (authToken) => {
    try {
      const response = await fetchWithAuth('/api/groups/my-groups-with-admin-status', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (!response.ok) {
        const err = await response.json();
        console.error('Error fetching admin groups:', err);
        return;
      }

      const data = await response.json();
      const adminGroups = Array.isArray(data.groups) ? data.groups.filter(g => g.is_admin) : [];
      const adminGroupIds = adminGroups.map(g => g.id);
      setAdminGroupIds(adminGroupIds);
    } catch (err) {
      console.error('Error fetching admin groups with status:', err);
    }
  };

  const handleDelete = async (gameId) => {
    if (!window.confirm('Are you sure you want to delete this game?')) return;

    try {
      const authToken = localStorage.getItem('authToken');
      if (!authToken) {
        navigate('/login');
        return;
      }

      const response = await fetchWithAuth(`/api/games/${gameId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (!response.ok) {
        const err = await response.json();
        alert(`Error: ${err.error}`);
        return;
      }

      alert('Game deleted successfully');
      fetchGames(authToken);
    } catch (error) {
      console.error('Error deleting game:', error);
      alert('Failed to delete game');
    }
  };

  const handleEdit = (gameId) => {
    navigate(`/edit-game/${gameId}`);
  };

  const handleEditTeam = (gameId) => {
    navigate(`/edit-team/${gameId}`);
  };

  const userCanEditGame = (game) => {
    return adminGroupIds.includes(game.group_id) || game.created_by === loggedInUserId;
  };

return (
  <div className="page-container">
    <UserBadge />
    <div className="center-content">
      <h2>Available Games</h2>

      {/* Top Buttons: Home and Create Game */}
<div className="button-group" style={{ marginBottom: '30px' }}>
  <button
    className="btn btn-primary"
    onClick={() => navigate('/')}
  >
    <FaHome />
    Home
  </button>
  <button
    className="btn btn-primary"
    onClick={() => navigate('/create-game')}
  >
    <FaPlus />
    Create Game
  </button>
</div>

      {/* Conditional Message */}
      {games.length === 0 ? (
        <p>You are not a member of any groups, or there are no games available.</p>
      ) : (
        <ul className="no-list-style">
          {games.map((game) => (
            <li key={game.id} style={{ marginBottom: '20px' }}>
              <h4 style={{ marginBottom: '5px', color: '#555' }}>
                Group: {game.group_name || 'Unknown Group'}
              </h4>
              <strong>{game.description}</strong>
              <div style={{ marginTop: '10px' }}>
                <button
                  onClick={() => navigate(`/games/${game.id}`)}
                  className="btn small-btn pastel-blue"
                >
                  <FaEye /> Details
                </button>

                {userCanEditGame(game) && (
                  <>
                    <button
                      onClick={() => handleDelete(game.id)}
                      className="btn small-btn pastel-red"
                      style={{ marginLeft: '10px' }}
                    >
                      <FaTrash /> Delete
                    </button>
                    <button
                      onClick={() => navigate(`/edit-game/${game.id}`)}
                      className="btn small-btn pastel-green"
                      style={{ marginLeft: '10px' }}
                    >
                      <FaEdit /> Edit Game
                    </button>
                    <button
                      onClick={() => navigate(`/edit-team/${game.id}`)}
                      className="btn small-btn pastel-yellow"
                      style={{ marginLeft: '10px' }}
                    >
                      <FaUsers /> Edit Team
                    </button>
                  </>
                )}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  </div>
);
};

export default Games;
